import Page from 'components/modules/public/pages/EmployerArticle';
export default Page;